/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Share_Card_SetsInputs */

const en_us2_workout_share_card_sets = /** @type {(inputs: Workout_Share_Card_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets`)
};

const pt_br2_workout_share_card_sets = /** @type {(inputs: Workout_Share_Card_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séries`)
};

const es_419_workout_share_card_sets = /** @type {(inputs: Workout_Share_Card_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Series`)
};

const pt_pt2_workout_share_card_sets = /** @type {(inputs: Workout_Share_Card_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séries`)
};

const fr_fr2_workout_share_card_sets = /** @type {(inputs: Workout_Share_Card_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séries`)
};

const de_de2_workout_share_card_sets = /** @type {(inputs: Workout_Share_Card_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sätze`)
};

const it_it2_workout_share_card_sets = /** @type {(inputs: Workout_Share_Card_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie`)
};

/**
* | output |
* | --- |
* | "Sets" |
*
* @param {Workout_Share_Card_SetsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_share_card_sets = /** @type {((inputs?: Workout_Share_Card_SetsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Share_Card_SetsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_share_card_sets(inputs)
	if (locale === "es-419") return es_419_workout_share_card_sets(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_share_card_sets(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_share_card_sets(inputs)
	if (locale === "de-DE") return de_de2_workout_share_card_sets(inputs)
	if (locale === "it-IT") return it_it2_workout_share_card_sets(inputs)
	return en_us2_workout_share_card_sets(inputs)
});
export { workout_share_card_sets as "workout-share.card_sets" }